import { AlertCircle } from 'lucide-react';
import { useAIGenerationEnabled } from '../hooks/useAIGenerationEnabled';

export function MaintenanceBanner() {
  const { isEnabled, loading } = useAIGenerationEnabled();

  if (loading || isEnabled) {
    return null;
  }

  return (
    <div className="bg-orange-50 border-b border-orange-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-start gap-3">
          <AlertCircle className="w-5 h-5 text-orange-600 flex-shrink-0 mt-0.5" />
          <div className="flex-1">
            <h3 className="text-sm font-semibold text-orange-900 mb-1">
              AI Generatie Tijdelijk Uitgeschakeld
            </h3>
            <p className="text-sm text-orange-800">
              We voeren momenteel onderhoud uit aan onze AI systemen. Je kunt je bestaande blogs en campaigns wel bekijken. Ingeplande emails worden normaal verstuurd.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
